var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"trigger"},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":_vm.effect}},[(_vm.show)?_c('div',{ref:"popover",class:['tooltip',_vm.placement]},[_c('div',{staticClass:"tooltip-arrow"}),_vm._v(" "),_c('div',{staticClass:"tooltip-inner"},[_vm._t("content",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2)]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c325da0","hasScoped":false,"buble":{"transforms":{}}}!./src/tooltip/template.html
// module id = 206
// module chunks = 0